import client from '../../shared/api/client';
import {
  PaginatedResponse,
  WithdrawalCheckStatusResult,
  WithdrawalOperation,
  WithdrawalSettings,
  WithdrawalStatus,
} from '../../shared/types';

interface WithdrawalBackendResponse<T> {
  success?: boolean;
  status?: string;
  data: T;
}

export interface WithdrawalFilters {
  page?: number;
  per_page?: number;
  user_id?: string | number;
  status?: WithdrawalStatus;
  currency?: string;
  address?: string;
  reference_id?: string;
  is_internal?: boolean;
}

export const listWithdrawals = async (
  filters: WithdrawalFilters = {}
): Promise<PaginatedResponse<WithdrawalOperation>> => {
  const params: Record<string, string | number | boolean | undefined> = {
    page: filters.page ?? 1,
    per_page: filters.per_page ?? 20,
  };
  if (filters.user_id) params.user_id = filters.user_id;
  if (filters.status) params.status = filters.status;
  if (filters.currency) params.currency = filters.currency;
  if (filters.address) params.address = filters.address;
  if (filters.reference_id) params.reference_id = filters.reference_id;
  if (typeof filters.is_internal === 'boolean') params.is_internal = filters.is_internal;

  const response = await client.get<WithdrawalBackendResponse<PaginatedResponse<WithdrawalOperation>>>(
    '/withdrawal',
    { params }
  );
  return response.data.data;
};

export const getWithdrawal = async (id: number): Promise<WithdrawalOperation> => {
  const response = await client.get<WithdrawalBackendResponse<WithdrawalOperation>>(
    `/withdrawal/${id}`
  );
  return response.data.data;
};

export const approveWithdrawal = async (id: number): Promise<WithdrawalOperation> => {
  const response = await client.post<WithdrawalBackendResponse<WithdrawalOperation>>(
    `/withdrawal/${id}/approve`,
    {}
  );
  return response.data.data;
};

export const rejectWithdrawal = async (
  id: number,
  reason?: string
): Promise<WithdrawalOperation> => {
  const response = await client.post<WithdrawalBackendResponse<WithdrawalOperation>>(
    `/withdrawal/${id}/reject`,
    reason ? { reason } : {}
  );
  return response.data.data;
};

export const checkWithdrawalStatus = async (
  id: number
): Promise<WithdrawalCheckStatusResult> => {
  const response = await client.post<WithdrawalBackendResponse<WithdrawalCheckStatusResult>>(
    `/withdrawal/${id}/check-status`,
    {}
  );
  return response.data.data;
};

export const getWithdrawalSettings = async (): Promise<WithdrawalSettings> => {
  const response = await client.get<WithdrawalBackendResponse<WithdrawalSettings>>(
    '/withdrawal/settings'
  );
  return response.data.data;
};

export const updateWithdrawalSettings = async (
  payload: Partial<WithdrawalSettings>
): Promise<WithdrawalSettings> => {
  const response = await client.put<WithdrawalBackendResponse<WithdrawalSettings>>(
    '/withdrawal/settings',
    payload
  );
  return response.data.data;
};
